import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Message } from '../../components/commons/message/message';
import PreHomeBrand from '../../components/prehomeBrand';
import { useImageSize } from '../../hooks/useImageSize';
import './index.scss';

export const PreHome = ({ setPreHomeVisited }) => {
  const history = useHistory();
  const { HomeStatics } = useSelector((state) => state.config);
  const { urlResized } = useImageSize(HomeStatics.prehome);

  const beginNavigation = () => {
    if (HomeStatics.situmAvailable) {
      history.push('/interactive_map');
    } else {
      sessionStorage.setItem('welcome', true);
      sessionStorage.setItem('gaSectionFromPreHome', true);
      setPreHomeVisited(true);
      history.replace('/');
    }
  };

  return (
    <>
      <div
        className={'prehome-wrapper'}
        style={{
          background: `url(${urlResized}) no-repeat center center fixed`,
          backgroundSize: 'cover',
          WebkitBackgroundSize: 'cover',
          MozBackgroundSize: 'cover',
          OBackgroundSize: 'cover',
          color: HomeStatics.prehomeColor,
        }}
      >
        <div className={'prehome-content'}>
          <div className={'prehome-brand'}>
            <PreHomeBrand color={HomeStatics.prehomeColor} />
          </div>
          <div className={'prehome-body'}>
            <div className={'prehome-title'}>
              <div>
                <Message
                  tag="p"
                  className={'zds-body-s-highlight'}
                  id={'store.intro'}
                />
                <Message
                  tag="h1"
                  className={'zds-heading-l-highlight'}
                  id={'store.title'}
                />
              </div>
            </div>
            <div className={'prehome-info zds-paragraph-m'}>
              <Message tag="p" id={'store.description'} />
            </div>
            <div className={'prehome-action'}>
              <button
                className="zds-heading-m-highlight"
                onClick={beginNavigation}
              >
                <Message id={'store.go'} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
